var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrayaAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1186_115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5379 40.6619H10.4611C7.01093 40.663 4.21398 43.46 4.21289 46.9101H43.7861C43.7861 43.4589 40.9892 40.6619 37.5379 40.6619Z",
    fill: "#A3937A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0004 11.5035C16.7091 11.5035 11.5039 16.7099 11.5039 24.3571V38.4845H36.4968V24.3571C36.4968 16.7099 31.2949 11.5035 24.0004 11.5035ZM32.3357 27.1715C31.7347 27.1715 31.247 26.6837 31.247 26.0827C31.247 22.1764 29.3286 18.5912 26.7832 17.7441C26.2116 17.5536 25.9024 16.9374 26.0929 16.3658C26.2834 15.7942 26.8997 15.485 27.4712 15.6756C30.9203 16.8263 33.4244 21.2031 33.4244 26.0827C33.4244 26.6837 32.9367 27.1715 32.3357 27.1715Z",
    fill: "#A3937A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33697 25.0887H1.08873C0.487752 25.0887 0 24.601 0 24C0 23.399 0.487752 22.9113 1.08873 22.9113H7.33697C7.93795 22.9113 8.4257 23.399 8.4257 24C8.4257 24.601 7.93795 25.0887 7.33697 25.0887Z",
    fill: "#A3937A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4149 13.0365C11.1264 13.0365 10.8487 12.9222 10.6451 12.7175L6.47966 8.55091C6.06159 8.11869 6.07356 7.42952 6.50688 7.01144C6.9293 6.60426 7.59778 6.60426 8.01912 7.01144L12.1846 11.178C12.6092 11.6037 12.6092 12.2929 12.1846 12.7175C11.9799 12.9222 11.7034 13.0365 11.4149 13.0365Z",
    fill: "#A3937A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0008 8.4257C23.3999 8.4257 22.9121 7.93795 22.9121 7.33697V1.08873C22.9121 0.487752 23.3999 0 24.0008 0C24.6018 0 25.0896 0.487752 25.0896 1.08873V7.33697C25.0896 7.93795 24.6018 8.4257 24.0008 8.4257Z",
    fill: "#A3937A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8192 12.8002C36.2182 12.8002 35.7305 12.3125 35.7305 11.7115C35.7305 11.423 35.8448 11.1464 36.0495 10.9417L40.2149 6.77626C40.6396 6.35056 41.3298 6.35056 41.7555 6.77517C42.1812 7.19977 42.1812 7.89003 41.7555 8.31572L37.5889 12.4812C37.3853 12.6859 37.1077 12.8002 36.8192 12.8002Z",
    fill: "#A3937A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9112 25.0887H40.663C40.062 25.0887 39.5742 24.601 39.5742 24C39.5742 23.399 40.062 22.9113 40.663 22.9113H46.9112C47.5122 22.9113 47.9999 23.399 47.9999 24C47.9999 24.601 47.5122 25.0887 46.9112 25.0887Z",
    fill: "#A3937A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1186_115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrayaAlert);
export default __webpack_public_path__ + "static/media/praya-alert.1a9a5f6f1857f5751011d7b7b34d55f3.svg";
export { ForwardRef as ReactComponent };